import React, { useEffect, useState } from 'react';
import { Button, Spinner, Badge } from 'react-bootstrap';
import { googleAuthConnect, googleStatus } from '../../api/common';
import { Alertassw } from '../Alertas/Alertassw';

/**
 * Botón de administración del calendario corporativo compartido.
 * Solo visible/usable por Admin.
 * Muestra el estado de conexión y permite iniciar el OAuth corporativo.
 */
export function GoogleCalendarConnect({ isAdmin = false }) {
  const [connected, setConnected] = useState(false);
  const [loading, setLoading] = useState(isAdmin); // solo carga si es admin

  // Consultar estado del calendario corporativo al montar (solo Admin)
  useEffect(() => {
    if (!isAdmin) return;
    googleStatus()
      .then(({ data }) => setConnected(!!data?.data?.connected))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [isAdmin]);

  // Escuchar el resultado del popup OAuth
  useEffect(() => {
    const handleMessage = (e) => {
      if (e.data === 'googleConnected') {
        setConnected(true);
        Alertassw('success', 'Calendario corporativo conectado correctamente');
      } else if (e.data === 'googleConnectionFailed') {
        Alertassw('error', 'No se pudo conectar el calendario corporativo');
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const handleConnect = async () => {
    setLoading(true);
    try {
      const { data: { data } } = await googleAuthConnect();
      const popup = window.open(data.url, 'google-oauth', 'width=600,height=700,scrollbars=yes');
      if (!popup) {
        Alertassw('warning', 'Permite ventanas emergentes para conectar Google Calendar');
      }
    } catch (err) {
      Alertassw('error', 'Error al iniciar conexión con Google');
    } finally {
      setLoading(false);
    }
  };

  if (!isAdmin) return null;

  if (loading) {
    return <Spinner size="sm" animation="border" />;
  }

  if (connected) {
    return (
      <Badge bg="success" className="p-2">
        📅 Calendario corporativo: Conectado
      </Badge>
    );
  }

  return (
    <Button variant="outline-warning" size="sm" onClick={handleConnect} disabled={loading}>
      📅 Conectar Calendario Corporativo
    </Button>
  );
}

export default GoogleCalendarConnect;

